import { answerContentSchema } from "@/schema/console/checking-assessments/AnswerContent";
import { z } from "zod";

export const answerSubCategoryDetailSchema = z.object({
  id: z.number(),
  content: z.string(),
  is_checked: z.coerce.boolean(),
  answer_contents: z.array(answerContentSchema),
});

export type AnswerSubCategoryDetail = z.infer<
  typeof answerSubCategoryDetailSchema
>;
